<template>
  <side-base>
    <div class="swrap">
      <div class="smain">
        <div class="three-a-row" v-if="!config.hideCampus && config.showOnlyRegistCampus">
          <div class="nav-title">
            仅看登记校区为所选校区的学员
            <van-checkbox v-model="studentCampusTypesChecked" icon-size="16px"
              >是</van-checkbox
            >
          </div>
        </div>
        <div class="row-box">
          <div class="three-a-title flex-between">教务信息</div>
            <van-cell
              v-if="!config.hideCampus"
              title="校区"
              is-link
              :value-class="['van-ellipsis', { selected: params.campusIds.length > 0 }]"
              :value="campusText || '请选择'"
              @click="chooseCampus"
            />
            <div class="three-a-row" v-if="!config.hideStudentStatus">
              <div class="nav-title">
                学员状态
                <van-checkbox v-if="!config.hideInvalStu" v-model="invalidChecked" icon-size="16px"
                  >查看无效学员</van-checkbox
                >
              </div>
              <div class="nav-div">
                <div class="nav-box" v-for="item of stuStaList" :key="item.id">
                  <div
                    class="item-nav"
                    :class="{
                      active: params.status && params.status.includes(item.val),
                      all: (!params.status || !params.status.length) && item.val === '',
                    }"
                    @click="triggerStuSta(item)"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="three-a-row" v-if="!config.hideStuClassStatus">
              <div class="nav-title">在班情况</div>
              <div class="nav-div">
                <div class="nav-box" v-for="item of stuClassStaList" :key="item.id">
                  <div
                    class="item-nav"
                    :class="{
                      active:
                        params.classStudentStatus && params.classStudentStatus.includes(item.value),
                    }"
                    @click="triggerClassStuSta(item)"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            <van-cell
              v-if="!config.hideCourse"
              title="课程"
              is-link
              :value-class="['van-ellipsis', { selected: params.curriculumIds.length > 0 }]"
              :value="curriculumAndPriceText || '请选择'"
              @click="chooseCourse"
            />
            <van-cell
              v-if="!config.hideClass"
              title="班级"
              is-link
              :value-class="['van-ellipsis', { selected: params.classList.length > 0 }]"
              :value="classText || '请选择'"
              @click="chooseClass"
            />
            <van-cell
              title="教务老师"
              is-link
              :value-class="['van-ellipsis', jiaowuTeacher ? 'selected':'']"
              :value="jiaowuTeacher||'请选择'"
              @click="chooseJiaowuTeacher"
              v-if="!config.hideJiaowuTeacherStatus"
            />
            <div class="three-a-row" v-if="!config.hideFollowTeacherStatus">
              <div class="nav-title">学员跟进人</div>
              <div class="nav-div">
                <div class="nav-box">
                  <div
                    class="item-nav"
                    :class="{ active: params.hasFollowTeacher === 1 }"
                    @click="triggerAssignStatus(1)"
                  >
                    有跟进人
                  </div>
                </div>
                <div class="nav-box">
                  <div
                    class="item-nav"
                    :class="{ active: params.hasFollowTeacher === 0 }"
                    @click="triggerAssignStatus(0)"
                  >
                    无跟进人
                  </div>
                </div>
              </div>
            </div>
            <van-cell
              title="跟进人"
              v-if="params.hasFollowTeacher === 1"
              is-link
              :value="followTeacherText || '请选择'"
              @click="chooseTeacher"
              :value-class="['van-ellipsis', { selected: params.followTeacherList.length > 0 }]"
            />
            <van-cell
              v-if="!config.hideComeform && comeFromList.length"
              title="招生来源"
              is-link
              :value-class="['van-ellipsis', { selected: comformDescStr }]"
              :value="comformDescStr || '请选择'"
              @click="chooseComformDesc"
            />
            <van-cell
              title="介绍人"
              is-link
              :value-class="['van-ellipsis', introducerName ? 'selected':'']"
              :value="introducerName||'请选择'"
              @click="choiceIntroducer"
              v-if="config.showIntroducer"
            />
        </div>
        <div class="row-box">
          <div class="three-a-title flex-between" :class="{ 'is-folded': folded }" @click.stop="folded = !folded">基本信息
            <van-icon name="arrow-down" class="icon"/>
          </div>
          <div v-show="!folded">
            <div class="three-a-row">
              <div class="nav-title">年龄范围</div>
              <div class="arrange-nav">
                <van-field readonly theme="round" :border="false" @click="pickerAgeMonth('ageFrom')">
                  <template #input>
                    <span v-if="params.ageFrom !== ''">
                      <span>{{ Math.floor(params.ageFrom / 12) }}岁</span>
                      <span v-if="params.ageFrom % 12 !== 0">{{ params.ageFrom % 12 }}月</span>
                    </span>
                    <span v-else style="color: var(--g5)">最小年龄</span>
                  </template>
                </van-field>
                <span style="padding: 0 calc(var(--gap) * 8)">-</span>
                <van-field
                  readonly
                  @click="pickerAgeMonth('ageTo', true)"
                  theme="round"
                  :border="false"
                >
                  <template #input>
                    <span v-if="params.ageTo !== ''">
                      <span>{{ Math.floor(params.ageTo / 12) }}岁</span>
                      <span v-if="params.ageTo % 12 !== 0">{{ params.ageTo % 12 }}月</span>
                    </span>
                    <span v-else style="color: var(--g5)">最大年龄</span>
                  </template>
                </van-field>
              </div>
            </div>
            <van-field v-if="config.isShowCustomSchool" label="公立学校" input-align="right" label-width="120">
              <template #input>
                <input class="wenben" v-model="params.customSchool" placeholder="请输入" maxlength="50"/>
              </template>
            </van-field>
            <van-cell
              v-if="config.isShowCustomGrade"
              title="公立年级"
              is-link
              :value-class="['van-ellipsis', customGrade ? 'selected':'']"
              :value="customGrade||'请选择'"
              @click="chooseCustomGrade"
            />
            <div class="three-a-row">
              <div class="nav-title">性别</div>
              <div class="nav-div">
                <div class="nav-box" v-for="item of sexListTyps" :key="item.id">
                  <div
                    class="item-nav"
                    :class="{
                      active: params.sexList && params.sexList.includes(item.value),
                    }"
                    @click="triggerItemNav(item, 'sexList')"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="three-a-row" v-if="!config.hideActiveStatus">
              <div class="nav-title">绑定家长端账号</div>
              <div class="nav-div">
                <div class="nav-box" v-for="item of activeStaList" :key="item.id">
                  <div
                    class="item-nav"
                    :class="{ active: params.active === item.value }"
                    @click="params.active = params.active === item.value ? '' : item.value"
                  >
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="three-a-row" v-if="!config.hideFaceStatus">
              <div class="nav-title">面部信息</div>
              <div class="nav-div">
                <div class="nav-box">
                  <div
                    class="item-nav"
                    :class="{ active: params.hasFace === true }"
                    @click="params.hasFace = params.hasFace === true ? '' : true"
                  >
                    已采集
                  </div>
                </div>
                <div class="nav-box">
                  <div
                    class="item-nav"
                    :class="{ active: params.hasFace === false }"
                    @click="params.hasFace = params.hasFace === false ? '' : false"
                  >
                    未采集
                  </div>
                </div>
              </div>
            </div>
            <van-cell
              title="创建人"
              v-if="config.isShowCreateTeacher"
              is-link
              :value-class="['van-ellipsis', createTeacher ? 'selected':'']"
              :value="createTeacher||'请选择'"
              @click="chooseCreateTeacher"
            />
            <van-cell
              v-if="!config.hideCreateDate"
              title="创建日期"
              is-link
              @click="chooseCreateCalendar"
              :value-class="{ selected: params.startCreateTime }"
            >
              <template>
                <div>
                  <span v-if="params.startCreateTime">
                    {{ params.startCreateTime | formatDatetime('yyyy-MM-dd') }}~{{
                      params.endCreateTime | formatDatetime('yyyy-MM-dd')
                    }}
                  </span>
                  <span v-else>请选择</span>
                </div>
              </template>
              <template #right-icon>
                <van-icon v-if="!params.startCreateTime" name="arrow" class="van-cell__right-icon" />
                <van-icon
                  v-else
                  name="cross"
                  @click.stop="() => clearDateRange('Create')"
                  class="van-cell__right-icon"
                />
              </template>
            </van-cell>
          </div>
        </div>
        <div class="row-box" v-if="config.enableIntentionStatus || !config.hideCardType || !config.hideChargeType || !config.hideStudentCourseRelations">
          <div class="three-a-row" v-if="config.enableIntentionStatus">
            <div class="nav-title">学员类型</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of stuTypesList" :key="item.id">
                <div
                  class="item-nav"
                  :class="{
                    active: params.intentionStatus === item.value,
                  }"
                  @click="
                    params.intentionStatus = params.intentionStatus === item.value ? '' : item.value
                  "
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="three-a-row" v-if="!config.hideCardType">
            <div class="nav-title">购课方式</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of cardTypes" :key="item.id">
                <div
                  class="item-nav"
                  :class="{
                    active: params.cardTypeList && params.cardTypeList.includes(item.value),
                    all:
                      (!params.cardTypeList || !params.cardTypeList.length) && item.value === '',
                  }"
                  @click="triggerCardType(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="three-a-row" v-if="!config.hideChargeType">
            <div class="nav-title">课程计费方式</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of chargeTypes" :key="item.id">
                <div
                  class="item-nav"
                  :class="{
                    active: params.chargeTypeList && params.chargeTypeList.includes(item.value),
                    all:
                      (!params.chargeTypeList || !params.chargeTypeList.length) && item.value === '',
                  }"
                  @click="triggerChargeType(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="three-a-row" v-if="!config.hideStudentCourseRelations">
            <div class="nav-title">学员课程状态</div>
            <div class="nav-div">
              <div class="nav-box" v-for="item of stuCrList" :key="item.id">
                <div
                  class="item-nav"
                  :class="{
                    active: params.courseRelations && params.courseRelations.includes(item.val),
                    all:
                      (!params.courseRelations || !params.courseRelations.length) && item.val === '',
                  }"
                  @click="triggerStuCR(item)"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row-box" v-if="customFieldList && customFieldList.length>0">
          <div class="three-a-title flex-between" :class="{ 'is-folded': folded1 }" @click.stop="folded1 = !folded1">自定义字段筛选
            <van-icon name="arrow-down" class="icon"/>
          </div>
          <!-- 自定义字段筛选 -->
          <div v-show="!folded1">
            <template v-for="(customObj,index) in customFieldList" >
              <!-- 文本 -->
              <template v-if="customObj.fieldDataType == 1">
                <van-field :label="customObj.fieldName" input-align="right" label-width="120" :key="customObj.id">
                  <template #input>
                    <input class="wenben" v-model="customFieldValueQueryDtoList[index].textValue" placeholder="请输入" maxlength="8"/>
                  </template>
                </van-field>
              </template>     
              <!-- 数字 -->
              <template v-if="customObj.fieldDataType == 2">
                <van-field :label="customObj.fieldName" input-align="right" label-width="120" :key="customObj.id">
                  <template #input>
                    <div class="number-wrapper">
                      <input class="number-input" v-price type="digit" v-model.number="customFieldValueQueryDtoList[index].fromNumberValue" placeholder="最小数字" maxlength="8"/>
                      &nbsp;-&nbsp;
                      <input class="number-input" v-price type="digit" v-model.number="customFieldValueQueryDtoList[index].toNumberValue" placeholder="最大数字" maxlength="8"/>
                    </div>
                  </template>
                </van-field>
              </template>
              <!-- 日期 -->
              <template v-if="customObj.fieldDataType == 3">
                <van-cell
                  :key="customObj.id"
                  :title="customObj.fieldName"
                  is-link
                  :value-class="['van-ellipsis', customFieldValueQueryDtoList[index].fromDateValue ? 'selected':'']"
                  :value="getCustomDatestr(customFieldValueQueryDtoList[index]) || '请选择'"
                  @click="chooseCustomDate(customFieldValueQueryDtoList[index])"
                >
                  <template #right-icon>
                    <van-icon v-if="!customFieldValueQueryDtoList[index].fromDateValue" name="arrow" class="van-cell__right-icon" />
                    <van-icon
                      v-else
                      name="cross"
                      @click.stop="clearCustomDate(customFieldValueQueryDtoList[index])"
                      class="van-cell__right-icon"
                    />
                  </template>
                </van-cell>
              </template>
              <!-- 选项 -->
              <template v-if="customObj.fieldDataType == 4 || customObj.fieldDataType == 5">
                <van-cell
                  :key="customObj.id"
                  :title="customObj.fieldName"
                  is-link
                  :value-class="['van-ellipsis', customFieldValueQueryDtoList[index].selectValueList.length ? 'selected':'']"
                  :value="getCustomSelectedStr(customFieldValueQueryDtoList[index], customObj)||'请选择'"
                  @click="chooseCustomSelected(customFieldValueQueryDtoList[index], customObj)"
                />
              </template>
            </template>
          </div>
        </div>
      </div>
      <side-foot cancelText="重置" @cancel="reset" @confirm="confirm(getRet())" />
    </div>
    <van-popup v-model="customSelectedShow" position="bottom" :safe-area-inset-bottom="true" @close="closeCustomSelectedPopup" get-container="body">
      <div class="custom-select-wrapper">
        <div 
          v-for="item in currentSelectedList" 
          :key="item.id" class="sel-item van-ellipsis" 
          :class="{selected : isCustomSelected(item.id)}"
          @click.stop="clickCustomSelected(item)">{{item.itemName}}</div>
      </div>
    </van-popup>
  </side-base>
</template>

<script>
import sideMixinBase from '@x3/js/side/0_mixin/mixin-base.js';

let defaultParams = {
  // 校区ids
  campusIds: [],
  campusList: [],
  // 课程id集合
  curriculumIds: [],
  curriculumList: [],
  // 班级id集合
  classIds: [],
  classList: [],
  // 学业状态
  status: [1],
  courseRelations: [],
  // 购课方式
  cardTypeList: [],
  // 计费方式
  chargeTypeList: [],
  // 在班情况
  classStudentStatus: [],
  // 招生来源
  comeFroms: [],
  comeFromsList: [],
  // 学员类型(意向,正式)
  intentionStatus: '',
  active: '',
  hasFace: '',
  // 公立学校
  customSchool: '',
  customGradeIds: [],
  customGradeList: [],
  // 跟进人ID集合
  followTeacherIds: [],
  followTeacherList: [],
  hasFollowTeacher: '',
  // 教务老师id集合
  jiaowuTeaIds: [],
  jiaowuTeaList: [],
  // 创建人id集合
  createTeacherIds: [],
  createTeacherList: [],
  followTeacherIdsMap: { //学员跟进人(筛选条件) 1教务老师 2销售老师	
    1: [],
    2: [],
  },
  sexList: [],
  ageFrom: '',
  ageTo: '',
  startCreateTime: '',
  endCreateTime: '',
  // 介绍人
  introducerIds: [],
  introducerList: [],
  studentCampusTypes: [],  
};

export default {
  name: '',
  inject: ['studentsStatusDict', 'studentsCourseRelationsDict'],
  mixins: [sideMixinBase],
  data() {
    return {
      // pageTitle: '学员筛选',
      // 学业状态列表
      activeStaList: [
        { id: 2, name: '已绑定', value: 1 },
        { id: 1, name: '未绑定', value: 0 },
      ],
      sexListTyps: [
        { id: 2, name: '未知', value: 2 },
        { id: 1, name: '男', value: 1 },
        { id: 3, name: '女', value: 0 },
      ],
      // 学业状态列表
      stuTypesList: [
        { id: 1, name: '正式学员', value: 0 },
        { id: 2, name: '意向学员', value: 1 },
      ],
      // 在班情况列表
      stuClassStaList: [
        { id: 1, name: '未入班', value: 1 },
        { id: 2, name: '已入班', value: 2 },
      ],
      cardTypes: [
        { id: 1, name: '课程', value: 0 },
        { id: 2, name: '课时包', value: 1 },
      ],
      chargeTypes: [
        { id: 1, name: '按课时计费', value: 1 },
        { id: 2, name: '按天自动计费', value: 2 },
      ],
      params: JSON.parse(JSON.stringify(defaultParams)),
      config: {
        hideCampus: true, // 默认不展示校区
        enableIntentionStatus: false,
        enableStudentStatusIds: [0, 1, 6],
        hideCourse: false, // 隐藏“课程”筛选项
        hideClass: false, // 隐藏“班级”筛选项
        hideFollowTeacherStatus: false, // 隐藏“跟进人状态”筛选项
        hideJiaowuTeacherStatus: true, // 隐藏“教务老师”筛选项
        hideComeform: false, // 隐藏“招生来源”筛选项
        isShowCustomSchool: false, // 隐藏“公立学校”筛选项
        hideStudentStatus: false, // 隐藏“学员状态”筛选项
        hideStudentCourseRelations: true,
        hideCardType: true,
        hideChargeType: true,
        hideInvalStu: false, // 隐藏“学员状态”筛选项
        hideStuClassStatus: false, // 隐藏“在班情况”筛选项
        hideActiveStatus: false, // 隐藏“绑定家长端账号”筛选项
        hideFaceStatus: false, // 隐藏“面部信息”筛选项
        hideCreateDate: false, // 隐藏“创建日期”筛选项
        showIntroducer: false, // 显示介绍人
        showOnlyRegistCampus: false, //显示是否仅看登记校区是当前校区
        isShowCustomGrade: false, 
        isShowCreateTeacher: false
      },
      comeFromList: [],
      // 自定义字段筛选参数.
      customFieldValueQueryDtoList:[],
      customFieldList: [],
      customSelectedShow: false,
      currentSelectedList: [],
      currentSelectedListValue: [],
      folded: false,
      folded1: true,
    };
  },
  computed: {
    campusText: function () {
      let cps = this.params.campusList,
        text = '';
      if (cps.length == 1) {
        text = cps[0].name;
      } else if (cps.length > 1) {
        text = `${cps.length}个校区`;
      }
      return text;
    },
    invalidChecked: {
      get() {
        return this.params.status.includes(99);
      },
      set(val) {
        if (val) {
          this.params.status.push(99);
        } else {
          let idx = this.params.status.indexOf(99);
          this.params.status.splice(idx, 1);
        }
        return true;
      },
    },
    studentCampusTypesChecked :{
      get() {
        return this.params.studentCampusTypes.length === 1 &&  this.params.studentCampusTypes[0] == 1;
      },
      set(val) {
        if (val) {
          this.params.studentCampusTypes = [1]          
        } else {
          this.params.studentCampusTypes = []
        }
      },
    },
    curriculumAndPriceText: function () {
      let cclist = this.params.curriculumList,
        text = '';
      if (cclist.length == 1) {
        text = cclist[0].curriculumName;
      } else if (cclist.length > 1) {
        text = `${cclist.length}个课价`;
      }
      return text;
    },
    classText: function () {
      let cpc = this.params.classList,
        text = '';
      if (cpc.length == 1) {
        text = cpc[0].className;
      } else if (cpc.length > 1) {
        text = `${cpc.length}个班级`;
      }
      return text;
    },
    stuStaList() {
      let arr = [];
      for (let prop in this.studentsStatusDict) {
        this.config.enableStudentStatusIds.includes(Number(prop)) &&
          arr.push({ id: prop, val: Number(prop), name: this.studentsStatusDict[prop] });
      }
      return arr;
    },
    stuCrList() {
      let arr = [];
      this.studentsCourseRelationsDict.forEach(item => {
        arr.push({
          id: item.value,
          val: item.value,
          name: item.name,
        });
      });
      return arr;
    },
    followTeacherText: function () {
      let tcs = this.params.followTeacherList,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个老师`;
      }
      return text;
    },
    comformDescStr: function () {
      let tcs = this.params.comeFromsList,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].itemName;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个来源`;
      }
      return text;
    },
    jiaowuTeacher: function () {
      let tcs = this.params.jiaowuTeaList,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个老师`;
      }
      return text;
    },
    introducerName: function () {
      let tcs = this.params.introducerList,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个学员`;
      }
      return text;
    },
    createTeacher: function () {
      let tcs = this.params.createTeacherList,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个老师`;
      }
      return text;
    },
    customGrade: function () {
      let sgs = this.params.customGradeList,
        text = '';
      if (sgs.length == 1) {
        text = sgs[0].itemName;
      } else if (sgs.length > 1) {
        text = `${sgs.length}个年级`;
      }
      return text;
    },
  },
  methods: {
    getCustomDatestr(item) {
      return item.fromDateValue ?  item.fromDateValue + '~' + item.toDateValue : '';
    },
    init() {
      let opts = this.$route.meta.options || {};
      if (opts.params) {
        let params = JSON.parse(JSON.stringify(opts.params));
        this.params = Object.assign(this.params, params);
        delete this.params.customFieldValueQueryDtoList;
        if (opts.params.customFieldValueQueryDtoList) {
          this.customFieldValueQueryDtoList = JSON.parse(JSON.stringify(opts.params.customFieldValueQueryDtoList));
        } else {
          this.customFieldValueQueryDtoList = [];
        }
      }
      if (opts.config) {
        let config = JSON.parse(JSON.stringify(opts.config));
        this.config = Object.assign(this.config, config);
        this.customFieldList = opts.config.customFieldList;
      }
    },
    getComeFrom() {
      this.comeFromList.splice(0);
      this.$api
        .getCustomFieldByFieldCode({ businessType: 'STUDENT_OFFICIALLY', fieldCode: 'come_from' })
        .then(res => {
          if (res.code === 200) {
            this.comeFromList = [];
            let { displayList = [], selectItemList = [] } = res.data || {};
            if (displayList[0] && displayList[0].display > 0) {
              this.comeFromList = selectItemList;
            }
          }
        });
    },
    // 考虑是否要去掉
    // 学员列表保持和筛选优化统一，重新添加参数控制是否放开 2022.04.19
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
      });

      let oIdsStr = this.params.campusIds.join(),
        nOdsStr = res.ids.join();
      // 如果选中的校区发生变化
      if (oIdsStr != nOdsStr) {
        this.params.campusIds = res.ids;
        this.params.campusList = res.list;

        this.params.curriculumIds = [];
        this.params.curriculumList = [];

        this.params.classIds = [];
        this.params.classList = [];
      }
    },
    // 选择课程
    async chooseCourse() {
      let res = await app.x3.side.xsCourse({
        id: this.params.curriculumIds[0] || '',
        config: {
          radio: true,
        },
        params: {
          // 校区ids
          campusIds: this.params.campusIds,
          campusList: this.params.campusList,
        },
      });

      let oIdsStr = this.params.curriculumIds.join();
      this.params.curriculumIds = res ? [res.curriculumId] : [];
      this.params.curriculumList = res ? [res] : [];

      if (oIdsStr !== this.params.curriculumIds.join()) {
        this.params.classIds = [];
        this.params.classList = [];
      }
    },
    // 选择班级
    async chooseClass() {
      let res = await app.x3.side.xsClass({
        ids: this.params.classIds,
        list: this.params.classList,
        params: {
          campusIds: this.params.campusIds,
          curriculumIds: this.params.curriculumIds,
          classStatus: 0,
        },
        config: {
          enableLeft: false,
          searchIcon: false,
          enableFilter: false,
        },
        filter: {
          enableCampusFilter: false,
        }
      });

      this.params.classIds = res.ids;
      this.params.classList = res.list;
    },
    async choiceIntroducer(){
      let ret = await app.x3.side.xsStudent({
        id: this.params.introducerIds[0] || '',
        params: {
          status: [1, 7],
        },
        defaultParams: {
          status: [1, 7],
        }
      });
      this.params.introducerIds = ret ? [ret.id] : [];
      this.params.introducerList = ret ? [ret] : [];
    },
    // 学业状态处理
    triggerStuSta(item) {
      let i = this.params.status.indexOf(item.val);
      if (i === -1) {
        this.params.status.push(item.val);
      } else {
        this.params.status.splice(i, 1);
      }
    },
    // 选择购课方式
    triggerCardType(item) {
      let i = this.params.cardTypeList.indexOf(item.value);
      if (i === -1) {
        this.params.cardTypeList.push(item.value);
      } else {
        this.params.cardTypeList.splice(i, 1);
      }
    },
    // 选择课程计费方式
    triggerChargeType(item) {
      let i = this.params.chargeTypeList.indexOf(item.value);
      if (i === -1) {
        this.params.chargeTypeList.push(item.value);
      } else {
        this.params.chargeTypeList.splice(i, 1);
      }
    },
    // 学员课程状态
    triggerStuCR(item) {
      let i = this.params.courseRelations.indexOf(item.val);
      if (i === -1) {
        this.params.courseRelations.push(item.val);
      } else {
        this.params.courseRelations.splice(i, 1);
      }
    },
    // 选择性别
    triggerItemNav(item, prop) {
      let i = this.params[prop].indexOf(item.value);
      if (i === -1) {
        this.params[prop].push(item.value);
      } else {
        this.params[prop].splice(i, 1);
      }
    },
    pickerAgeMonth(prop, isToAge) {
      let { ageFrom, ageTo } = this.params;
      let odlVal = this.params[prop] || 0;
      let age = Math.floor(odlVal / 12);
      let month = odlVal % 12;
      let opts = {
        ageIdx: age,
        monthIdx: month,
      };

      // 开始年龄有值，且设置的是结束年龄，设置结束年龄最小可选择的年
      if (ageFrom && isToAge) {
        opts.minAge = Math.floor(ageFrom / 12);
      }
      // 结束年龄有值，且设置的是开始年龄，设置开始年龄最大可选择的年
      if (ageTo && !isToAge) {
        opts.maxAge = Math.floor(ageTo / 12) + 1;
      }

      app.x3.picker.ageMonth(opts).then(res => {
        // 计算开始和结束年龄的月龄
        let form = ageFrom;
        let to = ageTo;

        // 根据要设置是开始还是结束，更新开始或结束年龄月龄
        if (isToAge) {
          to = res.age * 12 + res.month;
        } else {
          form = res.age * 12 + res.month;
        }

        // 开始和结束年龄都有值，对比下开始不能小于结束
        if (form && to && form > to) {
          this.$toast('开始年龄不能大于结束年龄');
          return false;
        }
        // 月龄为0，不展示
        this.$set(this.params, prop, res.age * 12 + res.month);
      });
    },
    // 在班情况处理
    triggerClassStuSta(item) {
      let i = this.params.classStudentStatus.indexOf(item.value);
      if (i === -1) {
        this.params.classStudentStatus.push(item.value);
      } else {
        this.params.classStudentStatus.splice(i, 1);
      }
    },
    clearCustomDate(item) {
      item.fromDateValue = '';
      item.toDateValue = '';
    },
    chooseCustomDate(item){
      app.x3.picker
        .dateRange({
          startDate: item.fromDateValue
            ? new Date(item.fromDateValue)
            : '',
          endDate: item.toDateValue
            ? new Date(item.toDateValue)
            : '',
          attrs: {
            allowSameDay: true,
            minDate: app.tool.date.getBasedOnToDayDate(-1, 'FullYear'),
          },
        })
        .then(res => {
          item.fromDateValue = app.tool.date.formatDatetime(res.startDate, 'yyyy-MM-dd');
          item.toDateValue = app.tool.date.formatDatetime(res.endDate, 'yyyy-MM-dd');
        })
        .catch(() => {
          console.log('取消选择或报错了');
        });
    },
    // 选择招生来源
    chooseComformDesc() {
      app.x3.side
        .xsComForm({
          ids: this.params.comeFroms,
          list: this.params.comeFromsList,
        })
        .then(res => {
          console.log(res);
          this.params.comeFroms = res ? res.ids : [];
          this.params.comeFromsList = res ? res.list : [];
        });
    },
    // 选择学员跟进人
    triggerAssignStatus(id) {
      this.params.hasFollowTeacher = this.params.hasFollowTeacher === id ? '' : id;
      this.params.followTeacherIds = [];
      this.params.followTeacherList = [];
      this.params.followTeacherIdsMap[2] = [];
    },
    // 选择跟进人
    async chooseTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.followTeacherIds,
        list: this.params.followTeacherList,
      });
      this.params.followTeacherIds = res.ids;
      this.params.followTeacherList = res.list;
      this.params.followTeacherIdsMap[2] = res.ids;
    },
    // 选择教务老师
    async chooseJiaowuTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.jiaowuTeaIds,
        list: this.params.jiaowuTeaList,
      });
      this.params.jiaowuTeaIds = res.ids;
      this.params.jiaowuTeaList = res.list;
      this.params.followTeacherIdsMap[1] = res.ids;
    },
    // 选择创建人
    async chooseCreateTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.createTeacherIds,
        list: this.params.createTeacherList,
      });
      this.params.createTeacherIds = res.ids;
      this.params.createTeacherList = res.list;
      // this.noFollowTeacher = false;
    },
    // 显示日期选择框
    chooseCreateCalendar() {
      // 这个筛选在点名排课列表筛选，添加试听选排课筛选复用
      // 关于快速选择日期范围的，两个地方有点差异
      // 点名排课列表筛选快速范围往后推日期，添加试听选排课筛选往前推
      // 所以这里要用参数有些差异
      let { config, quickRangeConfig } = this.$route.meta.options || {};
      let attrs = { allowSameDay: true };
      if (config && config.maxDate) {
        attrs.maxDate = config.maxDate;
      }

      app.x3.picker
        .dateRange({
          startDate: this.params.startCreateTime ? new Date(this.params.startCreateTime) : '',
          endDate: this.params.endCreateTime ? new Date(this.params.endCreateTime) : '',
          config: quickRangeConfig,
          attrs: attrs,
        })
        .then(res => {
          Object.assign(this.params, {
            startCreateTime: app.tool.date.formatDatetime(res.startDate, 'yyyy-MM-dd'),
            endCreateTime: app.tool.date.formatDatetime(res.endDate, 'yyyy-MM-dd')
          });
        })
        .catch(() => {
          console.log('取消选择或报错了');
        });
    },
    // 选择公立年级
    async chooseCustomGrade() {
      app.x3.side
        .xsGrade({
          ids: this.params.customGradeIds,
          list: this.params.customGradeList,
        })
        .then(res => {
          this.params.customGradeIds = res ? res.ids : [];
          this.params.customGradeList = res ? res.list : [];
        });
    },
    clearDateRange(str = 'Recovery') {
      this.params[`start${str}Time`] = '';
      this.params[`end${str}Time`] = '';
    },
    // 重置
    reset() {
      let opts = this.$route.meta.options || {};
      if (opts.defaultParams) {
        let params = JSON.parse(JSON.stringify(opts.defaultParams));
        this.params = Object.assign(JSON.parse(JSON.stringify(defaultParams)), params);
        this.customFieldValueQueryDtoList = JSON.parse(JSON.stringify(opts.defaultParams.customFieldValueQueryDtoList));
      } else {
        this.params = JSON.parse(JSON.stringify(defaultParams));
      }
    },
    async getRet() {
      return JSON.parse(
        JSON.stringify({
          params: {
            ...this.params,
            customFieldValueQueryDtoList: this.customFieldValueQueryDtoList,
          }
        })
      );
    },
    // 自定义字段展示
    getCustomSelectedStr(item, obj) {
      return obj.selectItemList.filter(sel=> item.selectValueList.includes(sel.id)).map(sel=>sel.itemName).join('、');
    },
    // 自定义字段选择
    chooseCustomSelected(item, obj) {
      this.currentSelectedListValue = [...item.selectValueList];
      this.currentSelectedList = obj.selectItemList;
      this.customSelectedShow = true;
      new Promise(rsv=>{
        this._customSelectedRsv = rsv;
      }).then(list=> {
        item.selectValueList = [...list];
      })
    },
    // 自定义字段判断是否选中
    isCustomSelected(id){
      return this.currentSelectedListValue.includes(id);
    },
    // 自定义字段弹窗关闭
    closeCustomSelectedPopup(){
      this._customSelectedRsv(this.currentSelectedListValue);
    },
    // 自定义字段点击
    clickCustomSelected(item){
      if (this.currentSelectedListValue.includes(item.id)) {
        this.currentSelectedListValue.splice(this.currentSelectedListValue.indexOf(item.id),1);
      } else {
        this.currentSelectedListValue.push(item.id);
      }
    },
  },
  created() {
    this.init();
    this.getComeFrom();
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .smain {
    flex: 1;
    overflow: auto;
    // background: var(--white);
    .wenben {
      height: 32px;
      padding: 0;
      border: 0;
      width: 160px;
      border-radius: 15px;
      background: var(--g1);
      text-align: right;
      padding: 0 10px;
    }
    .number-input {
      height: 32px;
      padding: 0;
      border: 0;
      width: 60px;
      border-radius: 15px;
      background: var(--g1);
      text-align: right;
      padding: 0 10px;
    }
    .row-box {
      background-color: #fff;
      margin: calc(var(--gap) * 12);
      border-radius: 8px;
      overflow: hidden;
      .three-a-title {
        padding: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 8) calc(var(--gap) * 16);
        &.is-folded {
          padding: calc(var(--gap) * 16);
        }
        .icon {
          transform: rotateZ(180deg);
          transition: all 0.5s;
        }
        &.is-folded {
          .icon {
            transform: rotateZ(360deg);
            transition: all 0.3s;
          }
        }
      }
    }
  }
  ::v-deep .van-cell__title {
    flex: unset;
    width: calc(var(--w) * 95);
  }
}
.custom-select-wrapper {    
  max-height: 70vh;
  overflow: auto;
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 8px;
  row-gap: 12px;
  .sel-item {
    text-align: center;
    padding: 8px 4px;
    background: var(--g1);
    color: var(--g8);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    border-radius: 4px;
    &.selected {
      color: var(--c1);
      background: rgba(var(--c1-rgb), 0.12);
    }
  }
}
</style>